import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { InputSelect } from 'components/atoms'

const ScreenSelector = props => {
  const [screens, setScreens] = useState()

  useEffect(() => {
    const options = []
    props.screens.data.forEach(screen => {
      if (!options.some(scr => scr.value === screen.screenId)) {
        options.push({
          value: screen.screenId,
          label: screen.screenId,
          brand: screen.brand,
        })
        setScreens(options)
      }
    })
  }, [])

  return (
    <InputSelect
      options={screens}
      placeholder='Select screen to control'
      value={JSON.parse(localStorage.getItem('screenApp')) || props.screenSelected}
      handleChange={value => props.handleChange(value)}
    />
  )
}

ScreenSelector.defaultProps = {
  screens: [],
  handleChange: () => {},
  screenSelected: {},
}

ScreenSelector.propTypes = {
  screens: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  handleChange: PropTypes.func,
  screenSelected: PropTypes.object,
}

export default ScreenSelector
